var RequisitionFormLoadingState;
(function (RequisitionFormLoadingState) {
    RequisitionFormLoadingState["ERROR"] = "error";
    RequisitionFormLoadingState["LOADING"] = "loading";
    RequisitionFormLoadingState["LOADED"] = "loaded";
})(RequisitionFormLoadingState || (RequisitionFormLoadingState = {}));

export { RequisitionFormLoadingState };
